module.exports = __webpack_public_path__ + "static/media/lobi-11.7368d52a.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/nutricheck_foliar/lobi-11.png
// module id = 1304
// module chunks = 3